import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { debounce } from 'lodash';
import config from '../../../../config';
import ToothChart from '../../charting/Index';
import { BootstrapSelect, TextInputField, TextAreaField } from '../../../commons/Inputs';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import CreateChartModal from './CreateChartModal';
import ChartingCheckbox from './ChartingCheckbox';
import { findOne } from '../../../actions/permissions';

let $ = window.jQuery;
let App = window.App;

export default class Charting extends Component {
    state = {
        isLoaded: false,
        checkboxes: {
            periodical_screenings: [],
            occlusions: [],
            appliances: [],
            tmds: []
        },
        charts: [],
        selectCharts: [],
        chartData: [],
        selectedChart: null,
        chartType: 'initial',
        chartId: 0,
        procedureCategory: 0,
        procedureCategories: [],
        periodicalScreenings: [
            {
                label: 'Gingivitis',
                value: 'gingivitis'
            },
            {
                label: 'Early periodontics',
                value: 'early-periodontics'
            },
            {
                label: 'Moderate periodontics',
                value: 'moderate-periodontics'
            },
            {
                label: 'Advanced periodontics',
                value: 'advanced-periodontics'
            }
        ],
        occlusions: [
            {
                label: 'Class molar',
                value: 'class-molar'
            },
            {
                label: 'Overjet',
                value: 'overjet'
            },
            {
                label: 'Overbite',
                value: 'overbite'
            },
            {
                label: 'Midline deviation',
                value: 'midline-deviation'
            },
            {
                label: 'Crossbite',
                value: 'crossbite'
            }
        ],
        appliances: [
            {
                label: 'Orthodontic',
                value: 'orthodontic'
            },
            {
                label: 'Stayplate',
                value: 'stayplate'
            }
        ],
        tmds: [
            {
                label: 'Clenching',
                value: 'clenching'
            },
            {
                label: 'Clicking',
                value: 'clicking'
            },
            {
                label: 'Trismus',
                value: 'trismus'
            },
            {
                label: 'Muscle spasm',
                value: 'muscle-spasm'
            }
        ],
        tmds_others: '',
        occlusions_others: '',
        periodical_screenings_others: '',
        appliances_others: '',
        remarks: ''
    };

    parseChartSelectData = (charts) => {
        let selectCharts = [
            {
                label: 'Select chart...',
                value: 0
            }
        ];

        for (let item of charts) {
            let tmp = {
                label: item.chart_name,
                value: item.id
            };

            selectCharts.push(tmp);
        }

        this.setState({
            selectCharts
        }, () => {
            $('#charts').selectpicker('refresh');

            if (selectCharts.length > 1) {
                if (this.state.chartId) {
                    $('#charts').selectpicker('val', this.state.chartId);
                    this.parseChartData();
                } else {
                    $('#charts').selectpicker('val', selectCharts[selectCharts.length - 1].value);

                    this.setState({
                        chartId: selectCharts[selectCharts.length - 1].value
                    }, () => {
                        this.parseChartData();
                    });
                }
            }
        });
    };

    getCharts = () => {
        App.blockUI({
            target: 'body',
            boxed: true
        });

        let url = `${config.apiUrl}dental/patients/${this.props.patientId}/chartings`;

        axios.get(url).then((res) => {
            this.setState({
                charts: res.data.data,
                isLoaded: true
            }, () => {
                if (this.state.charts.length <= 0) {
                    this.createChart();
                }

                this.props.refreshToTreatment();
                this.props.offToTreatment();
            });

            App.unblockUI('body');

            this.parseChartSelectData(res.data.data);
        }).catch((error) => {
            console.log('Getting Charts Error: ',error);
        });
    };

    addChartFill = (data) => {
        let url = `${config.apiUrl}dental/chartings/${this.state.selectedChart.id}/fills/multiple`;


        let user = this.props.user.toJS();
        let practitioner_id = user.role_info.id;
        let facility_id = user.user_info.facility_id;

        axios.post(url, {fills: data, practitioner_id: practitioner_id, facility_id: facility_id}).then((res) => {
            console.log('new data', res.data.data);

            // NOTES: This flow is not recommended but we'll
            // be doing this at this time until I finalized the optimized flow
            this.getCharts();


            // TODO: Optimized flow
            //
            // let newFills = res.data.data;
            // let charts = this.state.charts;
            // let chartIndex = charts.findIndex((chart) => {
            //     return parseInt(chart.id, 10) === parseInt(newFills[0].dental_chart_id, 10);
            // });
            //
            // for (let newFill of newFills) {
            //     let fills = charts[chartIndex].fills;
            //
            //     // Check each fill for already existing tooth number
            //     for (let fill of Object.keys(fills)) {
            //         // Check tooth number on each fill
            //         if (fills[fill].tooth_id === newFill.tooth_id) {
            //             // Tag this fill as inactive if already existing
            //             fills[fill].status = 'inactive';
            //         }
            //     }
            //
            //     // Apply the new fills
            //     charts[chartIndex].fills = fills;
            //
            //     charts[chartIndex].fills.push(newFill);
            // }
            //
            // this.setState({
            //     charts
            // }, () => {
            //     this.parseChartSelectData(charts);
            // });

            // console.log('charts', charts);
            // console.log('new fill', newFill);
            // console.log('chart index', chartIndex);

        }).catch((error) => {
            console.log(error);
        });
    };

    parseChartData = () => {
        let index = this.state.charts.findIndex((item) => {
            return item.id === parseInt(this.state.chartId, 10);
        });

        // When chart is not on the charts available
        if (index < 0) {
            return false;
        }

        // Get the selected chart
        let selectedChart = this.state.charts[index];
        let chartData = [];

        // Iterate each chart fills
        for (let fill of selectedChart.fills) {
            if (fill.status === 'inactive') {
                continue;
            }

            if (fill.type !== this.state.chartType) {
                continue;
            }

            chartData.push(fill);
        }

        let checkboxes = this.state.checkboxes;
        checkboxes['periodical_screenings'] = selectedChart.periodical_screenings;
        checkboxes['occlusions'] = selectedChart.occlusions;
        checkboxes['appliances'] = selectedChart.appliances;
        checkboxes['tmds'] = selectedChart.tmds;

        this.setState({
            selectedChart,
            chartData,
            checkboxes,
            remarks: selectedChart.remarks,
            tmds_others: selectedChart.tmds_others,
            occlusions_others: selectedChart.occlusions_others,
            periodical_screenings_others: selectedChart.periodical_screenings_others,
            appliances_others: selectedChart.appliances_others,
        }, () => {
            this.initEditableChartName();
            this.props.onUpdatedToothData(this.state.chartData);
        });
    };

    handleOpenCreateChart = () => {
        if (! findOne(this.props.permissions, ['charting.add', 'charting.*'])) {
            this.props.showNotification('error', 'You dont have the correct permission to create a new chart');

            return;
        }

        $('#createChart').modal('show');
    };

    modifyCheckboxes = (e) => {
        let checkboxes = this.state.checkboxes;
        let paramIndex = checkboxes[e.target.name].findIndex((item) => {
            return item.param === e.target.dataset.value;
        });

        if (paramIndex >= 0) {
            checkboxes[e.target.name][paramIndex] = {
                param: e.target.dataset.value,
                value: !checkboxes[e.target.name][paramIndex].value
            };

            return checkboxes;
        }

        let param = {
                param: e.target.dataset.value,
                value: true
            };

        // New Checkboxes Data
        checkboxes[e.target.name].push(param);

        return checkboxes;
    };

    handleCheckboxChange = (e) => {
        if (! this.state.selectedChart) {
            alert('Please select/create a chart first');

            e.preventDefault();
            return false;
        }

        let checkboxes = this.modifyCheckboxes(e);

        this.setState({
            checkboxes
        });

        let url = `${config.apiUrl}dental/chartings/${this.state.selectedChart.id}`;

        axios.put(url, checkboxes).then((res) => {
            console.log(res);
        }).catch((error) => {
            console.log(error);
        });
    };

    handleTextChange = (e) => {
        if (! this.state.selectedChart) {
            alert('Please select/create a chart first');

            e.preventDefault();
            return false;
        }

        let state = {};
        state[e.target.id] = e.target.value;

        this.setState(state);

        this.handleUpdateChart = debounce(this.handleUpdateChart, 1000); // deley every request
        this.handleUpdateChart(e.target);
    };

    handleUpdateChart = (target) => {
        let data = {};
        data[target.id] = target.value;

        let url = `${config.apiUrl}dental/chartings/${this.state.selectedChart.id}`;

        axios.put(url, data).then((res) => {
            console.log(res);
        }).catch((error) => {
            console.log(error);
        });
    };

    createChart = () => {
        let url = `${config.apiUrl}dental/chartings`;

        let data = {
            chart_name: `${moment().format("MMMM DD, YYYY")} Chart`,
            patient_id: this.props.patientId
        };

        axios.post(url, data).then((res) => {
            this.getCharts();
        }).catch((error) => {
            console.log(error);
        });
    };

    initEditableChartName = () => {
        // $.fn.editable.defaults.mode = 'inline';
        $.fn.editable.defaults.ajaxOptions = {type: "PUT"};

        if (! this.state.selectedChart) {
            return false;
        }

        //global settings
        $.fn.editable.defaults.inputclass = 'form-control';
        $.fn.editable.defaults.url = `${config.apiUrl}dental/chartings/${this.state.selectedChart.id}`;

        $('#chartName').editable({
            validate: function(value) {
                if ($.trim(value) === '') return 'This field is required';
            },
            success: () => {
                this.getCharts();
            }
        });
    };

    handleChartTypeChange = (e) => {
        let chartType = e.target.value;

        this.setState({
            chartType
        }, () => {
            this.parseChartData();
        });
    };

    componentWillMount() {

    }

    componentDidMount() {
        // if(sessionStorage.getItem('lastTab') == 'chartingPage') // last tab open
        // {
        //     this.getCharts();
        //     this.initEditableChartName();  
        // }
        

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'chartingPage'
            });

            if (index >= 0 && !this.state.isLoaded) {
                this.getCharts();
                this.initEditableChartName();
            }
        });

        this.getCharts();
    }

    render() {
        const { periodical_screenings, occlusions, appliances, tmds } = this.state.checkboxes;
        let chartName = 'Select a chart first';

        if (this.state.selectedChart) {
            chartName = (
                <a href="#" id="chartName" data-type="text"
                   data-name="chart_name" data-pk={this.state.selectedChart.id}
                   data-original-title="Update chart name">

                    {this.state.selectedChart.chart_name}
                </a>
            );
        }

        return(
            <div id="charting_container" ref="container">
                <div className="row">
                    <div className="form-group col-md-6 col-xs-12 col-sm-12">
                        <label className="control-label col-md-12">Chart Type</label>
                        <div className="col-md-6">
                            <div className="md-radio-list col-md-6 col-sm-12" style={{margin: '15px 0'}}>
                                <div className="md-radio">
                                    <input type="radio" name="chartType"
                                           id="chartTypeInitial"
                                           defaultChecked={true}
                                           onChange={this.handleChartTypeChange}
                                           className="md-check" value="initial"/>

                                    <label htmlFor="chartTypeInitial">
                                        <span/>
                                        <span className="check"/>
                                        <span className="box"/> Initial
                                    </label>
                                </div>
                            </div>

                            <div className="md-radio-list col-md-6 col-sm-12" style={{margin: '15px 0'}}>
                                <div className="md-radio">
                                    <input type="radio" name="chartType"
                                           id="chartTypeBasic"
                                           onChange={this.handleChartTypeChange}
                                           className="md-check" value="basic"/>

                                    <label htmlFor="chartTypeBasic">
                                        <span/>
                                        <span className="check"/>
                                        <span className="box"/> Basic
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-xs-12 col-sm-12">
                        <div className="col-md-6 col-xs-12 col-sm-12">
                            <BootstrapSelect id="charts" label="Chart Name"
                                             help="Select chart..."
                                             val={this.state.chartId}
                                             onChange={(e) => {this.setState({chartId: e.target.value}, () => {
                                                 this.parseChartData();
                                             })}}
                                             options={this.state.selectCharts} />
                        </div>

                        <div className="col-md-6 col-xs-12 col-sm-12">
                            <div>
                                <span>Current Active Chart</span> <br/>
                                {chartName}
                            </div>
                        </div>
                    </div>
                </div>

                <ToothChart {...this.props} chartType={this.state.chartType}
                            addChartFill={this.addChartFill}
                            selectedChart={this.state.selectedChart} />

                <hr/>
                <h4><strong>LEGEND</strong></h4>
                <div className="row">
                    <div className="col-md-3 col-xs-12 col-sm-6">
                        <h3>Periodical Screening</h3>
                        {this.state.periodicalScreenings.map((item, i) => {
                            return <ChartingCheckbox key={i}
                                                     item={item}
                                                     data={periodical_screenings}
                                                     name="periodical_screenings"
                                                     onChange={this.handleCheckboxChange}
                                                     id={`periodicalScreenings-${i}`} />;
                        })}
                        
                        <TextInputField val={this.state.periodical_screenings_others} id="periodical_screenings_others"
                                        onChange={this.handleTextChange}
                                        label="Others" help="Others"/>
                    </div>

                    <div className="col-md-3 col-xs-12 col-sm-6">
                        <h3>Occlusions</h3>
                        {this.state.occlusions.map((item, i) => {
                            return <ChartingCheckbox key={i}
                                                     item={item}
                                                     data={occlusions}
                                                     name="occlusions"
                                                     onChange={this.handleCheckboxChange}
                                                     id={`occlusions-${i}`} />;
                        })}

                        <TextInputField val={this.state.occlusions_others} id="occlusions_others"
                                        onChange={this.handleTextChange}
                                        label="Others" help="Others"/>
                    </div>

                    <div className="col-md-3 col-xs-12 col-sm-6">
                        <h3>Appliances</h3>
                        {this.state.appliances.map((item, i) => {
                            return <ChartingCheckbox key={i}
                                                     item={item}
                                                     data={appliances}
                                                     name="appliances"
                                                     onChange={this.handleCheckboxChange}
                                                     id={`appliances-${i}`} />;
                        })}

                        <TextInputField val={this.state.appliances_others} id="appliances_others"
                                        onChange={this.handleTextChange}
                                        label="Others" help="Others"/>
                    </div>

                    <div className="col-md-3 col-xs-12 col-sm-6">
                        <h3>TMDs</h3>
                        {this.state.tmds.map((item, i) => {
                            return <ChartingCheckbox key={i}
                                                     item={item}
                                                     data={tmds}
                                                     name="tmds"
                                                     onChange={this.handleCheckboxChange}
                                                     id={`tmds-${i}`} />;
                        })}

                        <TextInputField val={this.state.tmds_others} id="tmds_others"
                                        onChange={this.handleTextChange}
                                        label="Others" help="Others"/>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <TextAreaField val={this.state.remarks}
                                       onChange={this.handleTextChange}
                                       id="remarks" label="Remarks"
                                       help="Remarks"/>
                    </div>
                </div>

                <CreateChartModal getCharts={this.getCharts} patientId={this.props.patientId} />

                <FloatingActionButton
                    title="Add New Chart"
                    onClick={this.handleOpenCreateChart} />
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Charting/Charting.js
 **/